function SearchArea(props: any) {
  let myProps = {
    list: (inData: any) => { },
    get_pre_use_arr_by_ajax: () => { },
    listOpt: {},
    is_show_pre_exist: false,
    set_is_show_pre_exist: (inData: boolean) => { },
    ...props
  };

  const on_change_search_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_list_opt: any = {};
    change_list_opt[name] = value;
    myProps.list(change_list_opt);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
      <div className="flex flex-wrap items-center gap-3">
        {/* 검색 타입 선택 */}
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
            유형
          </label>
          <select
            name="s_word_type"
            value={myProps.listOpt.s_word_type}
            onChange={on_change_search_input}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-sm"
          >
            <option value="">전체</option>
            <option value="word">단어</option>
            <option value="stc">문장</option>
          </select>
        </div>

        {/* 검색어 입력 */}
        <div className="flex items-center gap-2 flex-1 min-w-[200px]">
          <input
            type="text"
            name="s_title_like"
            value={myProps.listOpt.s_title_like}
            placeholder="검색어를 입력하세요"
            autoComplete="off"
            onChange={on_change_search_input}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
          />
          <button
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors duration-200 text-sm whitespace-nowrap"
            onClick={() => {
              myProps.list({});
            }}
          >
            검색
          </button>
        </div>

        {/* 이용중 포함 체크박스 */}
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={myProps.is_show_pre_exist}
            onChange={(e) => {
              myProps.set_is_show_pre_exist(e.target.checked);
              if(e.target.checked){
                myProps.list({s_except_seq:""});
              }else{
                myProps.get_pre_use_arr_by_ajax();
              }
            }}
            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
          />
          <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
            이용중 포함
          </span>
        </label>
      </div>
    </div>
  );
};
export default SearchArea;